import React from 'react'

import ViewTemplates from "../../../../../../../../../core/manager/view-templates/view-templates"
import FormManager from "../../../../../../../../../core/gd-form/common/form-manager"
import FieldFormElement from "../../../../../../../../../core/fields3/render/form-elemnent"
import FormError from "../../../../../../../../../core/gd-form/common/form-error/form-error"
import FieldsFactory from "../../../../../../../../../core/fields3/fields-factory"
import {FieldType} from "../../../../../../../../../core/fields3/field-type"
import ButtonSubmit from "../../../../../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"
import HelpButtonField from "../../../../../../../../../core/gd-components/buttons/help-button/help-button-field"
import {ViewType} from "../../../../../../../../../core/gd/const/views/view-type"
import {ViewTypeConfigs} from "../../../../../../../../../core/gd/const/views/view-type-config";
import {AddView_OptionConfig} from "../../../../../../../../../core/gd-ui/add-view/@types"
import {getViewSystemType} from "../../../../../../../../../core/gd/const/views/get-view-system-type"

type Props = {
    config      : AddView_OptionConfig

    hidePopover : func

    onBack      : func
}

const debug = false
// const debug = "AddViewPreviewDefaultForm"

export default function AddViewPreviewDefaultForm(props: Props) {

    const layoutViewTemplates = new ViewTemplates()
    const viewSystemType = getViewSystemType(props.config.typeId)
    const templates = layoutViewTemplates.getViewTemplates(viewSystemType as unknown as ViewType)

    debug && console.log(debug, 'render', templates, props.config.typeId)

    //@ts-ignore
    const name =  ViewTypeConfigs[viewSystemType].menuName;

    const onSubmit = async (values: any) => {
        const template = _.find(templates, template=>template.id === values.templateId)

        debug && console.log(debug, 'onSubmit', template, props.config.typeId)

        gd.projectCollectionViews.addView(values.name, viewSystemType, template)

        props.hidePopover()
    }

    const initFormData = {
        name        :  name,
        templateId  : '_default',
    }

    const formStructure = {
        fields: {
            name:       { type: 'input',    isRequired: true},
            templateId: { type: 'select'},
        },
        onSubmit: onSubmit,
        isFormChanged: true,
    };

    const form = new FormManager(formStructure, initFormData)

    const view = ViewTypeConfigs[viewSystemType]!
    const templatesOptions: any = []

    _.map(templates, template => {
        templatesOptions.push({label: template.name, value: template.id})
    })

    const fieldName = FieldsFactory.get({
        fieldId         : 'name',
        type            : FieldType.STRING,
        isRequired      : true,
    })

    const fieldTemplate = FieldsFactory.get({
        fieldId         : 'templateId',
        type            : FieldType.DROPDOWN,
        options         : templatesOptions,
        showMenuMore    : false,
        noValueOption   : false,
        description     : 'View template'
    })

    debug && console.log(debug, 'render', view)

    return (
        <div className="flex-column-left-top h-100-percent p-l-10 p-r-10">
            <div className="back-link ui5-link-icon-default" onClick={props.onBack}>
                <div className="icon s-15 i5-long-arrow-left m-r-8 h-20"/>
                <div className="ui5-link-small">Select view</div>
            </div>

            <div className="flex-row-left-top m-t-35">
                <div className={Classes("flex-no-shrink w-45 m-t-3 m-r-10", view.iconSvg)}></div>

                <div className="flex-column-left-top">
                    <div className="ui5-title-app-name">{view.name}</div>
                    <div className="description ui5-txt-less-important-small m-t-5">{view.description}</div>
                </div>
            </div>

            <div className="flex-column-left-top w-100-percent m-t-30">
                <div className="flex-column-left-top w-100-percent">
                    <div className="ui5-txt-not-important-small m-b-8">Name</div>
                    <FieldFormElement className="w-100-percent" field={fieldName} form={form}/>
                    <FormError form={form} name="name"/>
                </div>

                <div className="flex-column-left-top w-100-percent m-t-15">
                    <div className="flex-row-left-center m-b-8">
                        <div className="ui5-txt-not-important-small">Template</div>
                        <HelpButtonField className="m-l-8" field={fieldTemplate}/>
                    </div>
                    <FieldFormElement className="w-100-percent" field={fieldTemplate} form={form}/>
                </div>
            </div>

            <div className="h-100-percent"/>

            <div className="flex-row-center-center w-100-percent m-b-30">
                <ButtonSubmit size="36" form={form} label="Add view"/>
            </div>
        </div>
    );
}
